import { BigNumber } from "@ethersproject/bignumber";
var NegativeOne = /*#__PURE__*/BigNumber.from(-1);
var Zero = /*#__PURE__*/BigNumber.from(0);
var One = /*#__PURE__*/BigNumber.from(1);
var Two = /*#__PURE__*/BigNumber.from(2);
var WeiPerEther = /*#__PURE__*/BigNumber.from("1000000000000000000");
var MaxUint256 = /*#__PURE__*/BigNumber.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
export { NegativeOne, Zero, One, Two, WeiPerEther, MaxUint256 };